import { isUrl } from 'infras/validator';
import { NextRouter } from 'next/router';

export function moveBackOrDefaultPath(router: NextRouter, defaultPath: string) {
  // Note: Internet Explorer and Opera start at 0, while Firefox, Chrome, and Safari start at 1.
  if (window.history.length > 1) {
    router.back();
    return;
  }
  router.replace(defaultPath);
}

export function routerPushSafety(router: NextRouter, unsafetyUrl: string) {
  // オープンリダイレクト対策
  if (isUrl(unsafetyUrl)) {
    const url = new URL(unsafetyUrl);
    // サイト内を許可
    if (url.origin !== process.env['JICOO_HOST']) {
      console.log('unsafe url', unsafetyUrl);
      return;
    }
  }
  // safety
  router.push(unsafetyUrl);
}

export function moveFromOrDefaultPath(router: NextRouter, defaultPath: string) {
  if (router.isReady && router.query.from) {
    // オープンリダイレクト対策
    if (isUrl(router.query.from as string)) {
      router.replace(defaultPath);
      return;
    }
    router.replace(router.query.from as string);
  } else {
    router.replace(defaultPath);
  }
}
